import React, { useEffect, useState } from 'react';
import { params } from '../../APIRoot';
import { getCurrentLanguage } from '../../LanguageHelper';
import { useKeycloakContext } from '../../contexts/AuthContext';

import './LegalBanner.css';

const DEFAULT_STATE = {
  legalBannerEnabled: false,
  legalContent: null,
  bannerClosed: false
};

const renderSwitch = (language, state) => {
  if (state.legalContent === null) {
    return '';
  }
  switch (language) {
    case 'en':
      return state.legalContent.englishContent || '';
    case 'fr':
      return state.legalContent.frenchContent || '';
    case 'nl':
      return state.legalContent.dutchContent || '';
    default:
      return state.legalContent.englishContent || '';
  }
};

const LegalBanner = () => {
  const [state, setState] = useState(DEFAULT_STATE);
  const { ...keycloak } = useKeycloakContext();
  useEffect(() => {
    const loadData = async () => {
      try {
        // APIFetch redirection on error make the application blinking
        const data = await fetch(
          process.env.REACT_APP_API_URL + 'legalbanner',
          params('GET', null, 'application/json')
        ).then(resp => resp.json());
        setState({ ...DEFAULT_STATE, ...data });
      } catch (error) {
        setState(DEFAULT_STATE);
      }
    };
    if (keycloak.authenticated) {
      loadData();
    }
  }, [keycloak.authenticated]);

  return (
    <div
      className="LegalBanner"
      style={{
        display:
          state &&
          state.legalContent &&
          state.legalBannerEnabled &&
          !state.bannerClosed
            ? 'block'
            : 'none'
      }}
    >
      <div className="legalbanner-content">
        <div className="legalbanner-footer">
          <button
            className="legalbanner-button"
            onClick={() => setState(DEFAULT_STATE)}
          >
            X
          </button>
        </div>
        <div
          style={{ padding: '8px 16px' }}
          dangerouslySetInnerHTML={{
           __html: renderSwitch(getCurrentLanguage(), state)
          }}
        />
      </div>
    </div>
  );
};

export default LegalBanner;
